import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Mail, User, Briefcase, Info } from 'lucide-react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

const Service3Page = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />

      <div className="container mx-auto px-4 py-8">
        <div className="max-w-4xl mx-auto">
          <button
            onClick={() => navigate('/')}
            className="flex items-center text-blue-600 hover:underline mb-6"
          >
            ← Retour à l'accueil
          </button>

          <div className="bg-white rounded-lg shadow-lg p-8">
            <div className="flex items-center gap-4 mb-6">
              <Mail className="text-blue-600" size={48} />
              <h1 className="text-4xl font-bold">Service 3</h1>
            </div>

            <div className="prose max-w-none">
              <p className="text-lg text-gray-700 mb-4">
                Notre Service 3 vous accompagne dans votre communication et votre gestion des contacts.
              </p>

              <h2 className="text-2xl font-bold mt-8 mb-4">Pourquoi nous choisir ?</h2>
              <div className="grid md:grid-cols-2 gap-6 mt-4">
                <div className="flex items-start gap-3">
                  <div className="bg-blue-100 p-2 rounded-lg">
                    <Mail className="text-blue-600" size={24} />
                  </div>
                  <div>
                    <h3 className="font-semibold mb-1">Communication fluide</h3>
                    <p className="text-gray-600">Échanges simplifiés avec vos clients</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="bg-blue-100 p-2 rounded-lg">
                    <User className="text-blue-600" size={24} />
                  </div>
                  <div>
                    <h3 className="font-semibold mb-1">Gestion centralisée</h3>
                    <p className="text-gray-600">Tous vos contacts au même endroit</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="bg-blue-100 p-2 rounded-lg">
                    <Briefcase className="text-blue-600" size={24} />
                  </div>
                  <div>
                    <h3 className="font-semibold mb-1">Automatisation</h3>
                    <p className="text-gray-600">Gagnez du temps avec nos outils</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="bg-blue-100 p-2 rounded-lg">
                    <Info className="text-blue-600" size={24} />
                  </div>
                  <div>
                    <h3 className="font-semibold mb-1">Analytics détaillés</h3>
                    <p className="text-gray-600">Suivez vos performances</p>
                  </div>
                </div>
              </div>

              <h2 className="text-2xl font-bold mt-8 mb-4">Contactez-nous</h2>
              <form className="space-y-4">
                <div>
                  <label className="block text-gray-700 mb-2">Votre nom</label>
                  <input
                    type="text"
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Jean Dupont"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 mb-2">Email</label>
                  <input
                    type="email"
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="jean@example.com"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 mb-2">Message</label>
                  <textarea
                    rows="4"
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Votre message..."
                  />
                </div>
                <button type="submit" className="bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700 transition">
                  Envoyer
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Service3Page;